var ko = require('knockout'),
  HOURS_TYPE = require('_js/constants/hours'),
  HOURS_COLOR = require('_js/constants/hours-color');

function TimeUnits(params) {
  var currentYear = new Date().getFullYear();
  this.year = params.year;
  this.timeDone = ko.observable(params.hours.done);
  this.timePlanned = ko.observable(params.hours.planned);
  this.timeRequired = ko.observable(params.hours.required);

  if (currentYear !== this.year) {
    this.timeMissing = ko.observable(0);
    this.shopping = ko.observable(0);
    this.timeRequired(0);
  } else {
    this.shopping = ko.observable(params.hours.shopping);
    this.timeMissing = ko.computed(function() {
      // // Incase you have done more hours than required.
      if (params.hours.missing < 0) {
        return 0;
      } else {
        return params.hours.missing;
      }
    }, this);
  }

  this.blocks = ko.observableArray([]);

  // Create the timeunits and add it to the visual blocks.
  var arr = [].concat(
    this.createTimeUnits(HOURS_TYPE.DONE, this.timeDone()),
    this.createTimeUnits(HOURS_TYPE.PLANNED, this.timePlanned()),
    this.createTimeUnits(HOURS_TYPE.SHOPPING, this.shopping()),
    this.createTimeUnits(HOURS_TYPE.EMPTY, this.timeMissing())
  );
  this.blocks(arr);
}

TimeUnits.prototype.createTimeUnits = function(unitType, amount) {
  var arr = [],
    hasHalfHour = false;

  // If we have half an hour.
  if (amount % 1 === 0.5) {
    hasHalfHour = true;
    amount = Math.floor(amount);
  }

  for (var i = 0; i < amount; i++) {
    arr.push(
      new TimeUnit({
        unitType: unitType,
        isHalf: false
      })
    );
  }

  if (hasHalfHour) {
    arr.push(
      new TimeUnit({
        unitType: unitType,
        isHalf: true
      })
    );
  }

  return arr;
};

// A single unit representing an hour (or half an hour).
function TimeUnit(settings) {
  this.settings = settings || {};
  this.width = ko.observable(15 + 'px');
  this.height = ko.observable(15 + 'px');
  this.margin = Math.ceil(this.width / 4) + 'px';
  this.rowNumber = settings.rowNumber;
  this.rowIndex = settings.rowIndex;
  // If the unit should represent a full hour or half an hour.
  this.isHalf = ko.observable(settings.isHalf);

  this.unitType = ko.observable(settings.unitType);
  this.background = 'url(assets/icons/timeunit.svg) no-repeat';
  this.classType = ko.computed(function() {
    return 'timeunit-' + this.unitType();
  }, this);
  this.backgroundColor = ko.computed(function() {
    return HOURS_COLOR[this.unitType()];
  }, this);

  this.type = HOURS_TYPE.DONE;
}

module.exports = TimeUnits;
